import moment from 'moment';
import { formatMDYWithParam } from 'utils/formatDate';

import { TIME_ZONES } from 'static/TimeZones';

export const getColumns = () => {
  const columns = [
    {
      field: 'created',
      headerName: 'Created at',
      flex: 1,
      valueFormatter: formatMDYWithParam,
    },
    {
      field: 'runAt',
      headerName: 'Run at',
      flex: 1,
      valueFormatter: (params) => moment(params.value).format('HH:mm:ss'),
    },
    {
      field: 'timezone',
      flex: 1,
      valueFormatter: ({ value }) =>
        TIME_ZONES.find((timezone) => timezone.utc[0] === value)?.text || value,
    },
    {
      field: 'interval',
      flex: 1,
    },
    { field: 'status' },
  ];

  return columns;
};
